import styled from "styled-components";

export const Wrapper = styled.div(({ theme }) => {
    return {
        padding: `0 ${theme.spacing.medium} ${theme.spacing.large} ${theme.spacing.medium}`,
        display: "flex",
        alignItems: "flex-start",
    };
});

export const InfoIconWrapper = styled.div(({ theme }) => {
    return {
        width: "16px",
        height: "16px",
        marginRight: theme.spacing.xxSmall,
    };
});
